export default __webpack_public_path__ + "static/teldat-4fcb42a336237e4af61ba109458fa034.png";